import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

const marquee1 = [
  "Mobile-Friendly Platform",
  "Eco-Friendly Travel Options",
  "Group Booking Discounts",
  "Real-Time Itinerary Updates",
  "Expert Travel Advisors",
  "Affordable Travel Deals",
];

const marquee2 = [
  "Secure Online Booking",
  "Verified Customer Reviews",
  "24/7 Customer Support",
  "Exclusive Travel Packages",
  "Special Member Discounts",
  "Local Destination Insights",
  "Affordable Travel Deals",
];

const MarqueeSection = () => {
  return (
    <div className="marquee-section fix section-padding pt-0">

      {/* FIRST SLIDER (LEFT TO RIGHT) */}
      <div className="marque-wrapper style-2">
        <Swiper
          modules={[Autoplay]}
          spaceBetween={30}
          slidesPerView={4}
          loop={true}
          speed={4000}
          autoplay={{
            delay: 0,
            disableOnInteraction: false,
          }}
          breakpoints={{
            320: { slidesPerView: 2 },
            768: { slidesPerView: 3 },
            1024: { slidesPerView: 4 },
          }}
        >
          {marquee1.map((text, index) => (
            <SwiperSlide key={index}>
              <div className="marque-text">
                <img src="assets/img/marque.png" alt="icon" />
                <h3>{text}</h3>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* SECOND SLIDER (RIGHT TO LEFT) */}
      <div className="marque-wrapper style-3">
        <Swiper
          dir="rtl"
          modules={[Autoplay]}
          spaceBetween={30}
          slidesPerView={4}
          loop={true}
          speed={4000}
          autoplay={{
            delay: 0,
            disableOnInteraction: false,
          }}
          breakpoints={{
            320: { slidesPerView: 2 },
            768: { slidesPerView: 3 },
            1024: { slidesPerView: 4 },
          }}
        >
          {marquee2.map((text, index) => (
            <SwiperSlide key={index}>
              <div className="marque-text">
                <img src="assets/img/marque.png" alt="icon" />
                <h3>{text}</h3>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

    </div>
  );
};

export default MarqueeSection;